/**
 * @file index.tsx
 *
 * @fileoverview Renders a label for form items.
 */
import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import styles from "./formLabel.module.scss";

const formLabel = cva([styles.formLabel], {
  variants: {
    required: {
      true: styles.required,
    },
    error: {
      true: styles.error,
    },
  },
});

interface FormLabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement>,
    VariantProps<typeof formLabel> {
  children: React.ReactNode;
}
export const FormLabel = ({
  children,
  error,
  required,
  ...props
}: FormLabelProps) => {
  return (
    <label
      className={formLabel({
        error,
        required,
      })}
      {...props}
    >
      {children}
    </label>
  );
};
export default FormLabel;
